import React from 'react';
import { Box, Typography } from '@material-ui/core';

export const NpsFieldPreview = React.memo(() => {
  const values = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <Box>
      <Box display='flex' justifyContent='space-between' mb={0.5}>
        <Typography variant='caption' color='textSecondary'>
          Not at all likely
        </Typography>
        <Typography variant='caption' color='textSecondary'>
          Extremely likely
        </Typography>
      </Box>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        {values.map((val) => (
          <Box
            key={val}
            display='flex'
            alignItems='center'
            justifyContent='center'
            style={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              border: '1px solid #bdbdbd',
              backgroundColor: '#f5f5f5',
            }}
          >
            <Typography variant='caption' color='textSecondary'>
              {val}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
});
